import React, { useState, useEffect, useRef } from 'react'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header'
import moment from 'moment'
import CustomTable from '../../components/shared/CustomTable';
import Search from '../../components/shared/Search';
import InputDate from '../../components/shared/InputDate';
import { useDispatch } from 'react-redux';
import { loadingActions } from '../../redux/actions';
import manifestAPI from '../../api/manifestAPI';
import { useParams, useLocation } from 'react-router-dom';

import './ManifestResendDetail.scss'
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const columns = [
  { id: 'orderNumber', label: 'N° Pedido', minWidth: 120 },
  { id: 'ticket', label: 'Ticket', minWidth: 100 },
  { id: 'guideNumber', label: 'Guía', minWidth: 150 },
  { id: 'compromiseDate', label: 'F. Despacho', minWidth: 150, format: (date) => date ? moment.utc(date).format('DD-MM-YYYY') : date },
  { id: 'cudsNumber', label: 'CUDs', minWidth: 100 },
  { id: 'itemsNumber', label: 'Items', minWidth: 100 },
]

const ManifestResendDetail = () => {
  const [modalSession, setModalSession] = useState(false)
  const [filters, setFilters] = useState({
    compromiseDate: null
  })
  const [textSearch, setTextSearch] = useState('')
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(4);
  const [total, setTotal] = useState(20);
  const [perPage, setPerPage] = useState(10);
  const [rows, setRows] = useState([])
  const params = useParams();
  const { state: { manifest } } = useLocation();
  const manifestId = params.id;
  const didMounRef = useRef(false);
  const didMounRef2 = useRef(false);
  console.log(manifest)

  useEffect(() => {
    fetchManifestDetail(currentPage, perPage)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if(didMounRef.current)onChangePerPage(perPage);
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [perPage]);

  useEffect(() => {
    onChangePerPage(perPage);
    // eslint-disable-next-line
  }, [filters])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if(didMounRef2.current) onChangePerPage(perPage);
      else didMounRef2.current = true;
      // console.log(numElem);
    }, 1000);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [textSearch])

  const formatFilters = ({ compromiseDate, textSearch }) => {
    const newFilters = {
      compromiseDate: compromiseDate && moment(compromiseDate).format('YYYY-MM-DD'),
      textSearch
    }
    return newFilters
  }

  const fetchManifestDetail = async (currentPage, perPage) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const { total, purchaseOrders } = await manifestAPI.getResendDetail(manifestId, currentPage, perPage, formatFilters({...filters, textSearch}));
      console.log(purchaseOrders);
      setRows(purchaseOrders)
      setTotal(total)
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      }
    }
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    fetchManifestDetail(numPage, perPage)
  }

  const onChangePerPage = async (perPage) => {
    if(perPage <= 0) return;
    setCurrentPage(1);
    await fetchManifestDetail(1, perPage)
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      <div className='manifest-resend-detail-container'>
        <Header
          title='Manifiestos / Reenvío de manifiestos'
          subtitle={moment(manifest.registerDate).format('ddd [  ]DD MMM YYYY [-] hh:mm A')}
          // onClickBtn1={() => console.log('object')}
          // iconBtn1={ExcelIcon}
          // btnTitle1='Exportar'
          // btnTitle2='Enviar'
          // onClickBtn2={() => console.log('object')}
          // iconBtn2={SendIcon}
        />
        <div className='manifest-resend-detail-subheader'>
          <div className='manifest-resend-detail-subheader-row'>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_store-gray.svg')} alt='store-gray'/>
              <span>{manifest.storeName}</span>
            </div>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_papper-check.svg')} alt='pappercheck' />
              <span><span style={{ fontWeight: 500 }}>{manifest.purchaseOrdersCount}</span> pedidos escaneados</span>
            </div>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_papper-check.svg')} alt='pappercheck' />
              <span><span style={{ fontWeight: 500 }}>{manifest.cudsCount}</span> CUDs</span>
            </div>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_papper-check.svg')} alt='pappercheck' />
              <span><span style={{ fontWeight: 500 }}>{manifest.productsCount}</span> Productos</span>
            </div>
          </div>
          <div className='manifest-resend-detail-subheader-row'>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_truck.svg')} alt='truck' />
              <span>{manifest.companyName}</span>
            </div>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_truck.svg')} alt='truck' />
              <span>{manifest.carrier}</span>
            </div>
            <div className='manifest-resend-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_truck.svg')} alt='truck' />
              <span>{manifest.carPlate}</span>
            </div>
          </div>
        </div>

        <div className='manifest-resend-detail-filters'>
          <div className='manifest-resend-detail-search'>
            <Search
              placeholder='N° Pedido, Ticket o Guía'
              value={textSearch}
              onChange={text => setTextSearch(text)}
            />
          </div>
          <div className='manifest-resend-detail-select'>
            <InputDate
              value={filters.compromiseDate}
              handleChange={(e) => setFilters({ ...filters, compromiseDate: e })}
              label='F. Despacho'
              fullWidth
            />
          </div>
        </div>
        <div className='manifest-resend-detail-table'>
          <CustomTable
            columns={columns}
            rows={rows}
            // onChangeNumElem={(num) => onChangePerPage(num)}
            total={total}
            currentPage={currentPage}
            changePage={onChangePage}
            perPage={perPage}
            onChangePerPage={(e) => setPerPage(e.target.value)}
            totalPages={totalPages}
          />
        </div>
      </div>
    </Layout>
  )
}

export default ManifestResendDetail
